/* eslint-disable import/no-unresolved, import/no-extraneous-dependencies */
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useAlert, AlertType } from 'src/components/AlertsProvider';
import { useOmniverseConfig } from './useConfig';
import { startSession, StreamingSession } from '../state/Sessions';

export const streamStartNotification = 'stream-start';

export function showStreamWarning(showAlert: (props: any) => void) {
  showAlert({
    id: 'stream-warning',
    type: AlertType.Warning,
    title: 'Streaming Session',
    text: 'Please click on the video window to enable fullscreen and keyboard input.',
  });
}

export default function useStreamStart(
  appId: string
): UseMutationResult<StreamingSession, Error, void> {
  const config = useOmniverseConfig();
  const navigate = useNavigate();
  const { showAlert } = useAlert();

  return useMutation({
    mutationFn: async () => startSession({ config, appId }),
    onSuccess: (session) => {
      navigate(`/omniverse/app/${appId}/sessions/${session.id}`);
    },
    onError: (error) => {
      showAlert({
        type: AlertType.Error,
        title: 'Failed to start streaming session',
        text: error.message,
      });
    },
  });
}
